import { Component } from '@angular/core';

@Component({
  selector: 'app-home13',
  templateUrl: './home13.component.html',
  styleUrls: ['./home13.component.scss']
})
export class Home13Component {}
